export const SET_BRANCHES = "SET_BRANCHES";
